import { render } from "./AdminPersonIframe.vue?vue&type=template&id=43fa4812&ts=true"
import script from "./AdminPersonIframe.ts?vue&type=script&lang=ts&external"
export * from "./AdminPersonIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__